import type { Anchor, Bounds, Measurement, Shape, Vec2 } from '../../geom';
import type { Construction } from '../../snap';
import type { Tool, ToolContext, ToolEvent, ToolMode } from '../types';

/** No-op defaults, so a tool implements only the events it cares about. */
export abstract class BaseTool implements Tool {
  abstract status(): string;
  abstract inProgress(): boolean;

  reference(): Anchor | null {
    return null;
  }

  constructions(): Construction[] {
    return [];
  }

  activate(_ctx: ToolContext): void {}

  placingPoint(): boolean {
    return true;
  }

  previews(_cursor: Vec2): Shape[] {
    return [];
  }

  measurements(): Measurement[] {
    return [];
  }

  region(): Bounds | null {
    return null;
  }

  modes(): readonly ToolMode[] {
    return [];
  }

  mode(): string | null {
    return null;
  }

  setMode(_id: string): void {}

  pointerDown(_ctx: ToolContext, _event: ToolEvent): void {}
  pointerMove(_ctx: ToolContext, _event: ToolEvent): void {}
  pointerUp(_ctx: ToolContext, _event: ToolEvent): void {}
  cancel(_ctx: ToolContext): void {}
}
